import { h } from 'preact';

export default props => (
	<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
		<circle cx="10" cy="4.15" r="1.5" />
		<circle cx="10" cy="10" r="1.5" />
		<circle cx="10" cy="15.85" r="1.5" />
	</svg>
);
